import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function DefinirSenhaPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [senha, setSenha] = useState("");
  const [confirmacao, setConfirmacao] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    setErro("");
    if (senha !== confirmacao) return setErro("As senhas não são iguais.");
    if (senha.length < 6) return setErro("A senha precisa ter pelo menos 6 caracteres.");
    setSalvando(true);
    try {
      await axios.post(`${API}/auth/password-reset/confirm`, { token, password: senha }, { withCredentials: true });
      toast.success("Senha definida. Faça login.");
      navigate("/login", { replace: true });
    } catch (err) {
      const detalhe = err?.response?.data?.detail;
      setErro(detalhe?.message || "Não foi possível definir a senha. Peça um novo link.");
    } finally {
      setSalvando(false);
    }
  };

  if (!token) {
    return (
      <main className="min-h-screen flex items-center justify-center bg-[#F4F7FB] p-6">
        <div className="max-w-md text-center">
          <h1 className="text-2xl font-bold text-[#001533] mb-2">Link inválido</h1>
          <p className="text-[#335480]">Peça um novo link em "Esqueci minha senha" na tela de login.</p>
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-[#F4F7FB] p-6">
      <form onSubmit={submit} data-testid="definir-senha-form" className="bg-white border border-[#D1DEEE] rounded-xl p-8 w-full max-w-md">
        <h1 className="text-2xl font-bold text-[#001533] mb-1" style={{ fontFamily: "Cabinet Grotesk" }}>Defina sua senha</h1>
        <p className="text-[#335480] text-sm mb-6">A partir daí você pode entrar com e-mail e senha.</p>
        <div className="space-y-4">
          <div>
            <Label htmlFor="senha" className="text-[#001533]">Nova senha</Label>
            <Input id="senha" data-testid="nova-senha" type="password" value={senha} onChange={(e) => setSenha(e.target.value)} className="h-11 mt-1 border-[#D1DEEE]" />
          </div>
          <div>
            <Label htmlFor="confirmacao" className="text-[#001533]">Repita a senha</Label>
            <Input id="confirmacao" data-testid="confirmar-senha" type="password" value={confirmacao} onChange={(e) => setConfirmacao(e.target.value)} className="h-11 mt-1 border-[#D1DEEE]" />
          </div>
        </div>
        {erro && <p role="alert" className="text-red-700 text-sm mt-4">{erro}</p>}
        <Button type="submit" disabled={salvando} data-testid="salvar-senha" className="w-full h-12 mt-6 bg-[#003882] hover:bg-[#00285e] text-white font-semibold">
          {salvando ? "Salvando..." : "Salvar senha"}
        </Button>
      </form>
    </main>
  );
}
